<template>
  <q-page class="bg-white q-pa-xl flex flex-center">
    <div class="form-wrap q-pa-xl">

      <!-- Заглавие -->
      <div class="text-center q-mb-xl">
        <!-- <q-icon name="assignment" size="34px" class="text-mint q-mb-sm" /> -->
        <h5 class="text-mint text-bold q-mb-none">
          {{ isEdit ? "Ажурирање на налог" : "Отворање нов налог" }}
        </h5>
        <p class="text-grey-7 text-caption q-mt-xs">
          <!-- Внеси податоци по желба. -->
        </p>
      </div>

      <!-- Форма -->
      <q-form ref="nalogForm" @submit.prevent="onSubmit" class="form-grid">

        <!-- РЕД 1 -->
      <q-input
  v-model="form.baratel"
  label="Барател "
  outlined
  dense
  color="mint"
  lazy-rules
  :rules="[rules.required]"
  class="required-field"
/>

       <div class="relative-position">
  <q-select
  v-model="form.firma"
  label="Фирма "
  outlined
  dense
  color="mint"
  clearable
  use-input
  input-debounce="0"
  :options="filteredFirmi"
  option-label="label"
  option-value="value"
  emit-value
  map-options
  @filter="filterFirmi"
  lazy-rules
  :rules="[rules.requiredSelect]"
  class="required-field"
>
  <template v-slot:prepend>
    <q-icon name="business" color="mint" />
  </template>
</q-select>
</div>


        <q-select
  v-model="form.aplikacija"
  :options="aplikaciiOptions"
  label="Апликација "
  outlined
  dense
  color="mint"
  emit-value
  map-options
  :loading="loadingAplikacii"
  lazy-rules
  :rules="[rules.requiredSelect]"
  class="required-field"
/>

      <q-input
  v-model="form.datumVnes"
  type="date"
  label="Датум внес "
  outlined
  dense
  color="mint"
  lazy-rules
  :rules="[rules.required]"
  class="required-field"
/>

        <!-- РЕД 2 -->
    <q-select
  v-model="form.prioritet"
  :options="prioriteti"
  label="Приоритет (1–5) "
  outlined
  dense
  color="mint"
  emit-value
  map-options
  lazy-rules
  :rules="[rules.requiredSelect]"
  class="required-field"
/>

    <q-select
  v-model="form.status"
  :options="statusiOptions"
  label="Статус "
  outlined
  dense
  color="mint"
  emit-value
  map-options
  lazy-rules
  :rules="[rules.requiredSelect]"
  class="required-field"
/>

<!-- 
        <q-select
          v-model="form.vrabotenID"
          :options="listaVraboteni"
          label="Вработен"
          outlined dense color="mint"
          emit-value map-options
        /> -->
<q-input
  v-model="form.opis"
  type="textarea"
  label="Опис "
  outlined
  dense
  color="mint"
  autogrow
  lazy-rules
  :rules="[rules.required]"
  class="required-field"
/>
        <!--  ДОДАДЕНО: ПРИКАЧИ СЛИКИ / ФАЈЛОВИ -->
        <div class="full-row q-mt-sm">

        <div class="upload-field" @click="selectFiles">
  <q-icon name="cloud_upload" class="upload-field-icon" />
  <span class="upload-field-text">
    {{ files.length ? `${files.length} избрани фајлови` : "Кликни за да прикачиш фајл" }}
  </span>

  <input
    ref="fileInput"
    type="file"
    accept="*/*"
    multiple
    class="hidden-input"
    @change="handleFileUpload"
  />
</div>


          <div v-if="files.length" class="q-mt-md">
            <q-table
              :data="files"
              :columns="fileColumns"
              row-key="id"
              flat
              bordered
              dense
              hide-bottom
              separator="horizontal"
            >
              <template v-slot:body-cell-preview="props">
                <q-td align="center">
                  <q-img
                    v-if="props.row.isImage"
                    :src="props.row.url"
                    style="width: 36px; height: 36px; border-radius: 6px"
                    contain
                  />
                  <q-icon v-else name="insert_drive_file" color="mint" />
                </q-td>
              </template>

              <template v-slot:body-cell-actions="props">
                <q-td align="center">
                  <q-btn
                flat
                round
                dense
                class="delete-btn"
                icon="delete"
                color="negative"
                @click="removeFile(props.row)"
              />

                </q-td>
              </template>
            </q-table>
          </div>

        </div>

        <!-- Копчиња -->
        <div class="btn-row full-row">
          <q-btn flat color="grey-6" no-caps label="Откажи" @click="onCancel" />

          <q-btn
  v-if="isEdit && (statusiMap[String(form.status)] !== 'Завршено')"
  outline
  color="mint"
  no-caps
  icon="lock"
  label="Затвори налог"
  class="q-mr-sm"
  @click="onCloseNalog"
/>


          <q-btn
            color="mint"
            no-caps
            class="text-bold"
            type="submit"
            :label="isEdit ? 'Сочувај измени' : 'Отвори налог'"
          />
        </div>

      </q-form>
    </div>
  </q-page>
</template>
<script>

import { getUser } from "@/services/db";
import { getStatusi } from "@/services/statusiService";
import { getFirmi } from "@/services/firmiService";
import { apiGetVraboteni } from "@/services/vraboteniService";
import { getAplikacii } from "@/services/aplikaciiService";
import { dodadiBaranja } from "@/services/baranjaApiService";

export default {
  name: "AzuriranjeNalozi",

  props: { id: { type: [String, Number], default: null } },

data() {
  return {
    isEdit: false,

   statusiOptions: [],
    statusiMap: {},


    prioriteti: [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5", value: 5 },
    ],

    farmi: [],              
    firmiOptions: [],       
    filteredFirmi: [],     

    listaVraboteni: [],
    aplikaciiOptions: [],
    loadingAplikacii: false,
    suggestions: [],

   form: {
  baratel: "",
  firma: "",
  opis: "",
  prioritet: null,
  status: null,
  datumVnes: null,
  aplikacija: null,
  sliki: [],
  pkid: null ,
  povik: false, 
},


    files: [],

    fileColumns: [
      { name: "preview", label: "", align: "center" },
      { name: "name", label: "Име", field: "name" },
      {
        name: "size",
        label: "KB",
        field: "sizeKB",
        align: "center",
        format: (v) => v.toFixed(1)
      },
      { name: "actions", label: "Акции", align: "center" }
    ],

   rules: {
  required: () => true,
  requiredSelect: () => true
}
  };
},


  created() {
  this.loadFirmi();
  this.loadVraboteni();
  this.loadAplikacii();
  this.loadStatusi();
//  Автоматски постави тековен датум ако е празно
if (!this.form.datumVnes) {
  this.form.datumVnes = this.todayISO();
}


  //  ЧИТАЊЕ НА ПОДАТОЦИ ОД ТЕЛЕФОНСКИ ПОВИК
  const raw = localStorage.getItem("novNalogOdPovik");
  if (raw) {
    const data = JSON.parse(raw);

    this.isEdit = false; 

    //  ПОЛНЕЊЕ НА ФОРМАТА
    this.form.baratel = data.klient || "";
    this.form.firma = data.firma || null;
    this.form.opis = data.opis || "";

    
    this.form.pkid = data.pkid || null;
     this.form.povik = true
    
    localStorage.removeItem("novNalogOdPovik");
    if (!this.form.datumVnes) {
  this.form.datumVnes = this.todayISO();
}
  }
},



  methods: {

    todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`; // формат за type="date"
},


    async loadStatusi() {
  try {
   const list = await getStatusi();

    this.statusiOptions = list.map(s => ({
      label: s.Opis,
      value: s.SifraID
    }));

    this.statusiMap = Object.fromEntries(
      list.map(s => [String(s.SifraID), s.Opis])
    );

    // default ако нема избрано
if (!this.form.status && this.statusiOptions.length) {
  const otvoreno = this.statusiOptions.find(x => x.label === "Отворено");
  this.form.status = otvoreno ? otvoreno.value : this.statusiOptions[0].value;
}


  } catch (err) {
    console.error("Грешка при вчитување статуси:", err);
    this.statusiOptions = [];
    this.statusiMap = {};
  }
},

    //  API фирми 
   async loadFirmi() {
  try {
    const data = await getFirmi();
this.firmiOptions = (data || []).map(f => ({
  label: f.Naziv,
  value: f.SifraID
}));
this.filteredFirmi = this.firmiOptions;
  } catch (err) {
    console.error("Грешка!", err);
  }
},
//  API вработени 
async loadVraboteni() {
  try {
    const data = await apiGetVraboteni(); 
    this.listaVraboteni = (data || []).map(v => ({
      label: v.Naziv,
      value: v.SifraID
    }));
  } catch (err) {
    console.error("Грешка при вчитување вработени:", err);
  }
},


    //  API апликации 
    async loadAplikacii() {
  this.loadingAplikacii = true;
  try {
   const data = await getAplikacii();
    this.aplikaciiOptions = (data || []).map(a => ({
      label: a.Opis,
      value: a.SifraID
    }));
  } finally {
    this.loadingAplikacii = false;
  }
},

    filterFirmi(val, update) {
  if (val === "") {
    update(() => {
      this.filteredFirmi = this.firmiOptions;
    });
    return;
  }

  update(() => {
    const needle = val.toLowerCase();
    this.filteredFirmi = this.firmiOptions.filter(f =>
      f.label.toLowerCase().includes(needle)
    );
  });
},

    selectFirma(name) {
      this.form.firma = name;
      this.suggestions = [];
    },

    //  FILE UPLOAD 
    selectFiles() {
      this.$refs.fileInput?.click();
    },

    async handleFileUpload(e) {
      const picked = Array.from(e.target.files);
      if (!picked.length) return;

      const mapped = await Promise.all(
        picked.map((f) => this.convertToBase64(f))
      );

      this.files.push(...mapped);

      this.form.sliki = this.files.map((f) => ({
        FileName: f.name,
        Fajl: f.base64
      }));

      e.target.value = "";
    },

    convertToBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result.split(",")[1];
          resolve({
            id: Date.now() + Math.random(),
            base64,
            name: file.name,
            sizeKB: file.size / 1024,
            isImage: file.type.startsWith("image/"),
            url: URL.createObjectURL(file)
          });
        };
        reader.readAsDataURL(file);
      });
    },

    removeFile(row) {
      this.files = this.files.filter((f) => f.id !== row.id);
      this.form.sliki = this.files.map((f) => ({
        FileName: f.name,
        Fajl: f.base64
      }));
    },

    onCancel() {
      this.$router.back();
    },

    //  SUBMIT TO API 
async onSubmit() {
  const hasEmptyRequired =
    !this.form.baratel ||
    !String(this.form.baratel).trim() ||
    !this.form.firma ||
    !this.form.aplikacija ||
    !this.form.prioritet ||
    !this.form.opis ||
    !String(this.form.opis).trim();

  if (hasEmptyRequired) {
    this.$q.notify({
      color: "white",
      textColor: "negative",
      icon: "warning",
      message: "Пополнете ги задолжителните полиња",
      position: "bottom",
      timeout: 2500,
      classes: "notify-required"
    });
    return;
  }

  try {
    const user = getUser();
    const partnerId = Number(this.form.firma);

    const payload = {
      PartnerID: partnerId || 0,
      List: [
        {
          Baratel: this.form.baratel || "",
          AplikacijaID: Number(this.form.aplikacija) || 0,
          Opis: this.form.opis || "",
          StepenItnost: Number(this.form.prioritet) || 0,
          StatusID: Number(this.form.status) || 0,
          VrabIDCreate: Number(user.username),
          pkid: this.form.pkid,
          povik: this.form.povik,
          Files: (this.files || []).map(f => ({
            Fajl: f.base64 || "",
            FileName: f.name || "image.jpg"
          }))
        }
      ]
    };

    console.log("FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

    const res = await dodadiBaranja(payload);
    console.log("BACKEND RESPONSE:", res);

   this.$q.notify({
  color: "white",
  textColor: "positive",
  icon: "check_circle",
  message: "Барањето е отворено!",
  position: "bottom",
  timeout: 2500,
  classes: "notify-success"
});

    this.$router.replace("/vraboten/pregledi");

  } catch (err) {
    console.warn("AXIOS ERROR OBJECT:", err);

    this.$q.notify({
      color: "negative",
      message: "Грешка при снимање!",
      icon: "error",
      position: "top"
    });
  }
}
  }
};
</script>


<style scoped>

.bg-white {
  background: #ffffff;
  min-height: 100vh;
  padding-top: 0 !important;
}

.form-wrap {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding-top: 0 !important;
}

.text-mint {
  color: #0e6b5f !important;
}


.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr) !important; 
  gap: 6px 12px !important;
}


.form-grid .q-field {
  margin: 0 !important;
  padding: 0 !important;
}

.form-grid .q-field__control {
  min-height: 30px !important;
  height: 30px !important;
}

.form-grid .q-field__native,
.form-grid .q-placeholder {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 12px !important;
}

.form-grid .q-field__label {
  top: 2px !important;
  font-size: 11px !important;
}

.form-grid .q-field__prepend,
.form-grid .q-field__append {
  padding: 0 !important;
}

.form-grid .q-icon {
  font-size: 16px !important;
}

/* Responsive */
@media (max-width: 1100px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 600px) {
  .form-grid {
    grid-template-columns: 1fr !important;
  }
}


.white-upload {
  border: 1px solid #d0d0d0 !important;
  border-radius: 6px !important;
  padding: 6px !important;
  min-height: 60px !important;

  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 2px !important;

  background: white;
  transition: 0.2s ease;
}

.white-upload:hover {
  border-color: #0e6b5f !important;
  background: #f4faf7 !important;
}


.white-upload .q-icon {
  font-size: 22px !important;
}


.white-upload .text-caption {
  font-size: 11px !important;
  margin: 0 !important;
}


.hidden-input {
  display: none !important;
}


.q-table td {
  padding: 4px 6px !important;
  font-size: 11px !important;
}

.q-table th {
  padding: 4px 6px !important;
  font-size: 11px !important;
}

.q-table img {
  width: 28px !important;
  height: 28px !important;
  border-radius: 4px !important;
}

.q-table .q-btn {
  font-size: 10px !important;
  width: 20px !important;
  height: 20px !important;
  min-height: 20px !important;
  padding: 0 !important;
}


.form-grid .btn-row {
  grid-column: 1 / -1 !important;    
  width: 100% !important;

  display: flex !important;
  justify-content: center !important;  
  align-items: center !important;

  gap: 12px !important;
  margin-top: 16px !important;
}

.btn-row .q-btn {
  height: 32px !important;
  min-height: 32px !important;
  padding: 0 20px !important;
  font-size: 13px !important;
  border-radius: 6px !important;
}


.upload-field {
  width: 100%;
  height: 30px;                        
  border: 1px solid #c8c8c8;
  border-radius: 6px;
  background: white;

  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 6px;

  cursor: pointer;
  transition: 0.15s ease;
}

.upload-field:hover {
  border-color: #0e6b5f;               
}

.upload-field-icon {
  font-size: 18px;
  color: #0e6b5f;
}

.upload-field-text {
  font-size: 12px;
  color: #555;
  white-space: nowrap;
}

.hidden-input {
  display: none;
}

.q-table .delete-btn {
  width: 22px !important;       
  height: 22px !important;
  min-height: 22px !important;

  padding: 0 !important;
  margin: 0 !important;

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  border-radius: 50% !important;
}

.q-table .delete-btn .q-icon {
  font-size: 16px !important;   
}
/* поголеми, исти копчиња */
.btn-row {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 12px !important;
  margin-top: 18px !important;
}

.btn-row .q-btn {
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 22px !important;
  font-size: 14px !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
}

/* Откажи (бело, без рамка) */
.btn-cancel {
  background: #ffffff !important;
  color: #0e6b5f !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
}

/* Отвори/Сочувај (mint) */
.btn-submit {
  background: #0e6b5f !important;
  color: #ffffff !important;
  box-shadow: 0 2px 10px rgba(14,107,95,0.25) !important;
}

/* Затвори налог (ако го имаш) да личи исто големо */
.btn-close {
  border-radius: 10px !important;
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 18px !important;
}
:deep(.required-field .q-field__label) {
  display: inline-flex !important;
  align-items: center !important;
}

:deep(.required-field .q-field__label::after) {
  content: " *";
  color: #e53935 !important;
  font-weight: 700;
}
:deep(.notify-success) {
  border: 1px solid  #0e6b5f ;
  font-weight: 600;
}
:deep(.notify-required) {
  border: 1px solid #e53935;
  font-weight: 600;
}
</style>
